import React, { useEffect, useState } from 'react';
import styles from './all-app-admin.module.scss';
import {
  Box,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
  FormControlLabel,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { ruRU } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import clsx from 'clsx';
import { format, Locale } from 'date-fns';
const russianLocale = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;

import { ru } from 'date-fns/locale/ru';
import { useNavigate, useParams } from 'react-router-dom';
import { apiClient } from 'shared/api';
import ArrowRight from 'shared/assets/icons/arrow_right.svg';
import DateIconRaw from 'shared/assets/icons/date.svg';
import FilterIcon from 'shared/assets/icons/filter.svg';
import { CheckboxInput } from 'shared/ui/checkbox-input';
import { SearchInput } from 'shared/ui/search-input';
import { SliderRangeInput } from 'shared/ui/slider-range-input';
import { DashboardHeaderBackLink } from 'widgets/dashboard-header-back-link';
import * as XLSX from 'xlsx';

const customRuLocale: Locale = {
  ...ru,
  options: {
    ...ru.options,
    weekStartsOn: 1,
  },
};
export const AllAppAdmin = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const title = type == 'select' ? 'Заявки на подбор транспортного средства' : 'Заявки на лизинг';
  const headerTitlePriceText = type == 'select' ? 'Бюджет на покупку' : 'Стоимость лизинга';

  const url = type == 'select' ? '/select-applications/allAdmin' : '/leasing-applications/allAdmin';

  const urlFilter = window.location.search.split('=')[1];

  const [allApp, setAllApp] = useState([]);

  const [news, setNews] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [processed, setProcessed] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [closed, setClosed] = useState(false);
  const [canceled, setCanceled] = useState(false);

  const getAllApp = async () => {
    if (urlFilter) {
      try {
        const response = await apiClient.post(url + 'Status', { status: urlFilter });
        const data = response?.data?.data
          ? response.data.data.filter((item: any) => item.fulfilled !== false)
          : [];
        setAllApp(data);
      } catch (error) {
        console.error('Ошибка при получении данных: ', error);
      }
    } else {
      try {
        const response = await apiClient.get(url);
        const data = response?.data?.data
          ? response.data.data.filter((item: any) => item.fulfilled !== false)
          : [];
        setAllApp(data);
      } catch (error) {
        console.error('Ошибка при получении данных: ', error);
      }
    }
  };

  useEffect(() => {
    getAllApp();
    setNews(false);
    setProcessing(false);
    setProcessed(false);
    setConfirmation(false);
    setConfirmed(false);
    setCompleted(false);
    setClosed(false);
    setCanceled(false);
    setSearch('');
    setFirstDate(null);
    setSecondDate(null);
  }, [url, urlFilter]);

  // const isApply = (status:string) => {
  //   return status == 'Подтверждена'
  // }
  // const isWaiting = (status:string) => {
  //   return status == 'Ожидает подтверждение'
  // }

  const isNew = (status: string) => {
    return status == 'Новая';
  };
  const isProcessing = (status: string) => {
    return status == 'В обработке';
  };
  const isProcessed = (status: string) => {
    return status == 'Обработана';
  };
  const isConfirmation = (status: string) => {
    return status == 'Ожидает подтвержд.';
  };
  const isConfirmed = (status: string) => {
    return status == 'На оформлении';
  };
  const isCompleted = (status: string) => {
    return status == 'Выполнена';
  };
  const isClosed = (status: string) => {
    return status == 'Закрыта';
  };
  const isCanceled = (status: string) => {
    return status == 'Отменена';
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const marksPrice = [
    {
      value: 1000000,
      label: '1 млн',
    },
    {
      value: 50000000,
      label: '50 млн',
    },
  ];
  const dataStyle = {
    width: 160,
    '&': {
      borderRadius: '10px',
      height: '46px',
      fontSize: '16px',
      fontWeight: 500,
      backgroundColor: '#ECF3F6',
      '&': {
        height: '100%',
        maxHeight: '48px',
        backgroundColor: '#ECF3F6',
        color: '#001317',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '21.19px',
        letterSpacing: '0.02em',
        borderRadius: '10px',
        '&:hover': {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#8AB6EF!important',
            borderWidth: '1px!important',
          },
        },
        '&.Mui-error': {
          backgroundColor: '#FFC5C5',
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#FF9D9D',
            fontSize: '16px',
            borderWidth: '1px',
          },
        },
      },
      '.MuiInputBase-root': {
        fontSize: '16px!important',
        fontWeight: 500,
      },
      '.MuiOutlinedInput-root': {
        fontSize: '16px!important',
        fontWeight: 500,
      },
      '.MuiFormHelperText-root.Mui-error': {
        marginLeft: '0!important',
        color: '#FF3A3A!important',
        fontSize: '10px',
        fontWeight: 500,
        lineHeight: '11.77px',
      },
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: '#8AB6EF!important',
          borderWidth: '1px!important',
        },
      },
      '&:active': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: '#4794EF!important',
          borderWidth: '1px!important',
        },
      },
      '&:focus': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: '#4794EF!important',
          borderWidth: '1px!important',
        },
      },
      '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: '#4794EF!important',
          borderWidth: '1px!important',
        },
      },
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: '#B5D4F9!important',
        borderWidth: '1px!important',
        outline: 'none!important',
      },
      '.MuiInputBase-input': {
        border: 'none',
        outline: 'none!important',
        fontSize: '16px!important',
        fontWeight: 500,
        // padding: '11px 12px',
        '::placeholder': {
          color: '#96A8B8',
          opacity: 1,
        },
      },
      '.MuiOutlinedInput-input': {
        fontSize: '16px!important',
        fontWeight: 500,
      },
    },
  };
  const [priceValue, setPriceValue] = React.useState<any>([1000000, 50000000]);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [firstDate, setFirstDate] = React.useState<any>();
  const [secondDate, setSecondDate] = React.useState<any>();

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [search, setSearch] = useState('');
  const [error, setError] = useState(false);

  const handleInputChange =
    (setter: React.Dispatch<React.SetStateAction<string>>) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setter(e.target.value);
      setError(false);
    };

  const onSubmitFilter = async () => {
    const body = {
      search,
      statuses: [
        news && 'Новая',
        processing && 'В обработке',
        processed && 'Обработана',
        confirmation && 'Ожидает подтвержд.',
        confirmed && 'На оформлении',
        completed && 'Выполнена',
        closed && 'Закрыта',
        canceled && 'Отменена',
      ].filter(Boolean),
      startDate: firstDate ? new Date(firstDate).toISOString() : undefined,
      endDate: secondDate ? new Date(secondDate).toISOString() : undefined,
      minBudget: priceValue[0],
      maxBudget: priceValue[1],
    };

    try {
      const url = type == 'select' ? '/select-applications/filter' : '/leasing-applications/filter';
      const response = await apiClient.post(url, body);
      setAllApp(response.data);
      handleClose();
    } catch (error) {
      console.error('Ошибка фильтрации: ', error);
    }
  };

  const formatToInitials = (fullName: string) => {
    if (!fullName) return '';

    const parts = fullName.trim().split(/\s+/);
    if (parts.length === 0) return '';

    const lastName = parts[0];
    const initials = parts
      .slice(1)
      .map((p) => p.charAt(0).toUpperCase() + '.')
      .join('');

    return `${lastName} ${initials}`.trim();
  };

  const handleChangeSlider = (event: Event, newValue: any) => {
    setPriceValue(newValue as any);
  };
  const DateIcon = (props: any) => <SvgIcon component={DateIconRaw} inheritViewBox {...props} />;

  const flattenForExcel = (obj: any): Record<string, string | number | boolean | null> => {
    if (!obj) return {};
    const result: Record<string, string | number | boolean | null> = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value === null || value === undefined) {
        result[key] = null;
      } else if (value instanceof Date) {
        result[key] = format(value, 'dd.MM.yyyy HH:mm');
      } else if (typeof value === 'string' && (key === 'createdAt' || key === 'updatedAt' || key === 'publishedAt')) {
        try {
          result[key] = format(new Date(value), 'dd.MM.yyyy HH:mm');
        } catch {
          result[key] = value;
        }
      } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        if (key === 'kp' && value && typeof value === 'object' && 'url' in value) {
          result[key] = (value as { url?: string }).url ?? '';
        } else if (key === 'user' && value && typeof value === 'object' && 'id' in value) {
          result[key] = (value as { id?: number }).id ?? '';
        } else {
          result[key] = JSON.stringify(value);
        }
      } else if (key === 'car_params') {
        let params = value;
        if (typeof value === 'string') {
          try {
            params = JSON.parse(value);
          } catch {
            result[key] = value;
            continue;
          }
        }
        if (Array.isArray(params) && params.every((item: any) => item?.fieldName != null)) {
          result[key] = params
            .map((item: any) => {
              const val = Array.isArray(item.fieldValue)
                ? item.fieldValue.join(', ')
                : item.fieldValue;
              return `${item.fieldName}:${val ?? ''}`;
            })
            .join(', ');
        } else {
          result[key] = typeof value === 'string' ? value : JSON.stringify(value);
        }
      } else if (Array.isArray(value)) {
        result[key] = JSON.stringify(value);
      } else {
        result[key] = value as string | number | boolean;
      }
    }
    return result;
  };

  /* eslint-disable camelcase */
  const columnHeadersRu: Record<string, string> = {
    id: '№ заявки',
    documentId: 'ID документа',
    createdAt: 'Дата создания',
    updatedAt: 'Дата обновления',
    publishedAt: 'Дата публикации',
    inn: 'ИНН',
    bio: 'ФИО',
    email: 'E-mail',
    phone: 'Телефон',
    condition: 'Состояние',
    quantity: 'Количество ТС',
    budget: 'Бюджет',
    budget_num: 'Бюджет (число)',
    price: 'Стоимость',
    price_num: 'Стоимость (число)',
    pay_method: 'Способ покупки',
    destination: 'Место поставки',
    currency: 'Валюта',
    car_type: 'Тип ТС',
    car_subtype: 'Подтип ТС',
    car_brand: 'Марка',
    vehicle: 'Модель',
    car_subtype_id: 'ID подтипа',
    car_params: 'Параметры ТС',
    agent_inn: 'ИНН агента',
    agent_phone: 'Телефон агента',
    agent_bio: 'ФИО агента',
    agent_email: 'E-mail агента',
    agent_reward: 'Вознаграждение агента',
    status_app: 'Статус заявки',
    status_admin: 'Статус админа',
    fulfilled: 'Заполнена',
    custom_uid: 'UID',
    offersCount: 'Офферы (заполнено/всего)',
    kp: 'Файл КП (ссылка)',
    user: 'ID пользователя',
    initial_payment: 'Первоначальный взнос',
    lease_period: 'Срок лизинга',
    payment_type: 'Тип оплаты',
    revenue: 'Выручка',
  };
  /* eslint-enable camelcase */

  const handleExportToExcel = () => {
    if (!allApp || allApp.length === 0) return;
    const flattened = allApp.map((row: any) => flattenForExcel(row));
    const ws = XLSX.utils.json_to_sheet(flattened);
    const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const addr = XLSX.utils.encode_col(C) + '1';
      const key = ws[addr]?.v;
      if (key && columnHeadersRu[key]) {
        ws[addr].v = columnHeadersRu[key];
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Заявки');
    const fileName = `заявки_${type}_${format(new Date(), 'yyyy-MM-dd_HH-mm')}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const renderHeaderRow = () => {
    return (
      <TableRow className={styles.tableHeadRow}>
        <TableCell className={`${styles.tableHeadCellFirst} ${styles.tableHeadCell}`}>
          № заявки
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Дата обновления
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          Дата создания
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          ИНН
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          ФИО
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableCellMobile}`} align='left'>
          {headerTitlePriceText}
        </TableCell>
        <TableCell className={styles.tableHeadCell} align='left'>
          Статус заявки
        </TableCell>
        <TableCell className={`${styles.tableHeadCell} ${styles.tableHeadCell}`} align='right' />
        <TableCell className={`${styles.tableHeadCellLast} ${styles.tableHeadCell}`} align='right'>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: 'auto' }}>
            <button
              className={styles.exportBtn}
              onClick={handleExportToExcel}
              disabled={!allApp || allApp.length === 0}
            >
              Выгрузить в Excel
            </button>
            <button className={styles.filterBtn} onClick={handleClick} aria-describedby={id}>
              <span>Фильтр</span>
            <SvgIcon
              component={FilterIcon}
              className={styles.svgFilter}
              inheritViewBox
              sx={{ fontSize: '18px' }}
            />
          </button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '.MuiPopover-paper': {
                backgroundColor: '#ECF3F6',
                marginTop: '10px',
                borderRadius: '20px',
                boxShadow: 'none',
                border: '1px solid #CFE2E8',
              },
            }}
          >
            <div className={styles.filterWrapper}>
              <div className={styles.filterSearch}>
                <SearchInput error={error} value={search} onChange={handleInputChange(setSearch)} />
              </div>
              <div className={styles.filterStatus}>
                <div className={styles.filterStatusText}>Статус</div>
                <div className={styles.filterStatusWrapper}>
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput name={'new'} onClick={() => setNews(!news)} checked={news} />
                    }
                    label='Новая'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setProcessing(!processing)}
                        name={'processing'}
                        checked={processing}
                      />
                    }
                    label='В обработке'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setProcessed(!processed)}
                        name={'processed'}
                        checked={processed}
                      />
                    }
                    label='Обработана'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setConfirmation(!confirmation)}
                        name={'confirmation'}
                        checked={confirmation}
                      />
                    }
                    label='Ожидает подтверждения'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setConfirmed(!confirmed)}
                        name={'confirmed'}
                        checked={confirmed}
                      />
                    }
                    label='На оформлении'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setCompleted(!completed)}
                        name={'completed'}
                        checked={completed}
                      />
                    }
                    label='Выполнена'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setClosed(!closed)}
                        name={'closed'}
                        checked={closed}
                      />
                    }
                    label='Закрыта'
                  />
                  <FormControlLabel
                    sx={{
                      margin: 0,
                      '.MuiFormControlLabel-label': {
                        fontSize: '16px',
                        fontWeight: 500,
                        letterSpacing: '0.02em',
                      },
                    }}
                    control={
                      <CheckboxInput
                        onClick={() => setCanceled(!canceled)}
                        name={'canceled'}
                        checked={canceled}
                      />
                    }
                    label='Отменена'
                  />
                </div>
              </div>
              <div className={styles.filterDate}>
                <div className={styles.filterStatusText}>Выберите период</div>
                <div className={styles.filterDateWrapper}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    localeText={russianLocale}
                    adapterLocale={customRuLocale}
                  >
                    <DatePicker
                      value={firstDate}
                      format='dd.MM.yyyy'
                      onChange={(newFirstDate) => setFirstDate(newFirstDate)}
                      slots={{ openPickerIcon: DateIcon }}
                      slotProps={{
                        textField: { variant: 'outlined', size: 'small', placeholder: 'с' },
                        openPickerButton: { disableRipple: true },
                      }}
                      sx={dataStyle}
                    />
                    <DatePicker
                      value={secondDate}
                      format='dd.MM.yyyy'
                      onChange={(newSecondDate) => setSecondDate(newSecondDate)}
                      slots={{ openPickerIcon: DateIcon }}
                      slotProps={{
                        textField: { variant: 'outlined', size: 'small', placeholder: 'по' },
                        openPickerButton: { disableRipple: true },
                      }}
                      sx={dataStyle}
                    />
                  </LocalizationProvider>
                </div>
              </div>
              <div className={styles.filterPrice}>
                <div className={styles.filterStatusText}>Сумма бюджета, ₽</div>
                <div className={styles.filterPriceWrapper}>
                  <SliderRangeInput
                    name='priceRange'
                    title={''}
                    value={priceValue}
                    onChange={handleChangeSlider}
                    marks={marksPrice}
                    step={100000}
                    defaultValue={[0, 50000000]}
                    min={0}
                    max={50000000}
                    symbol={'₽'}
                  />
                </div>
              </div>
              <div className={styles.filterSubmitBtn}>
                <div className={styles.filterBtnWrapper}>
                  <button className={styles.btnClose} onClick={handleClose}>
                    Отмена
                  </button>
                  <button className={styles.btnSubmit} onClick={onSubmitFilter}>
                    Применить
                  </button>
                </div>
              </div>
            </div>
          </Popover>
          </div>
        </TableCell>
      </TableRow>
    );
  };

  const renderRows = (rows: any) => {
    return rows.map((row: any) => (
      <TableRow
        className={styles.tableBodyRow}
        key={row.id}
        sx={{ '& td, & th': { border: 0 }, marginTop: '10px' }}
      >
        <TableCell
          className={`${styles.tableBodyCellFirst} ${styles.tableBodyCell}`}
          component='th'
          scope='row'
        >
          {row.id}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {format(new Date(row.updatedAt), 'dd.MM.yyyy')}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {format(new Date(row.createdAt), 'dd.MM.yyyy')}
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='left'>
          {row.inn}
        </TableCell>
        <TableCell
          className={`${styles.tableBodyCell} ${styles.tableCellMobile} ${styles.tableBio}`}
          align='left'
        >
          {formatToInitials(row.bio)}
        </TableCell>
        <TableCell
          className={`${styles.tableBodyCell} ${styles.tableCellMobile} ${styles.tableBio}`}
          align='left'
        >
          {new Intl.NumberFormat('ru-RU').format((row.price || row.budget) as number)} ₽
        </TableCell>
        <TableCell
          className={clsx([
            `${styles.tableBodyCell}`,
            isNew(row.status_app) && `${styles.statusNew}`,
            isProcessing(row.status_app) && `${styles.statusProcessing}`,
            isProcessed(row.status_app) && `${styles.statusProcessed}`,
            isConfirmation(row.status_app) && `${styles.statusConfirmation}`,
            isConfirmed(row.status_app) && `${styles.statusConfirmed}`,
            isCompleted(row.status_app) && `${styles.statusCompleted}`,
            isClosed(row.status_app) && `${styles.statusClosed}`,
            isCanceled(row.status_app) && `${styles.statusCanceled}`,
          ])}
          align='left'
        >
          <div className={styles.statusWrapper}>{row.status_app}</div>
        </TableCell>
        <TableCell className={`${styles.tableBodyCell} ${styles.tableCellMobile}`} align='right' />
        <TableCell className={`${styles.tableBodyCellLast} ${styles.tableBodyCell}`} align='right'>
          <div className={styles.tableCellCountWrapper}>
            <div className={styles.tableCellCount}>{row.offersCount}</div>
            <IconButton
              disableRipple
              sx={{
                width: '40px',
                height: '40px',
                marginRight: 0,
              }}
              onClick={() => navigate(`/dashboard/admin/app/${type}/${row.documentId}`)}
              edge='end'
              className={styles.svgIcon}
            >
              <SvgIcon component={ArrowRight} inheritViewBox sx={{ fontSize: '18px' }} />
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <Box className={styles.allPage}>
      <DashboardHeaderBackLink link={'/dashboard/admin/last'} title={title} />
      <Box>
        <TableContainer component={Box} className={styles.tableContainer}>
          <Table className={styles.table} sx={{ minWidth: 1070 }} aria-label={title}>
            <TableHead className={styles.tableHead}>{renderHeaderRow()}</TableHead>
            <TableBody className={styles.tableBody}>{renderRows(allApp)}</TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};
